const GAS_GALON_COST = 3.6;

export const getDistanceInMiles = (matrixDistance: number) => matrixDistance / 1609.3;

export const getVehicleDistanceCost = (mpg: number, matrixDistance: number) => {
  const distanceInMiles = getDistanceInMiles(matrixDistance);

  return distanceInMiles / mpg * GAS_GALON_COST;
};